// Sjåførdokumentasjon: typer, tilstand og språk. Speilet i functions/src/driverDocuments.js.

export const DOCUMENT_TYPES = {
  insurance: { label: 'Forsikring', required: true, requiresDate: true },
  license:   { label: 'Transportløyve', required: true, requiresDate: true },
  ysk:       { label: 'YSK (yrkessjåførkompetanse)', required: true, requiresDate: true },
};

export const REQUIRED_KEYS = Object.keys(DOCUMENT_TYPES);

export const LANGUAGES = [
  { code: 'nb', label: 'Norsk' },
  { code: 'en', label: 'Engelsk' },
  { code: 'pl', label: 'Polsk' },
  { code: 'lt', label: 'Litauisk' },
  { code: 'sv', label: 'Svensk' },
  { code: 'de', label: 'Tysk' },
  { code: 'ru', label: 'Russisk' },
  { code: 'ar', label: 'Arabisk' },
  { code: 'so', label: 'Somali' },
  { code: 'other', label: 'Annet' },
];

export function languageLabel(code) {
  return LANGUAGES.find(l => l.code === code)?.label ?? code;
}

function isoDay(now) {
  return new Date(now).toISOString().slice(0, 10);
}

// Antall hele dager fra i dag til utløpsdatoen (negativt etter utløp), eller null uten dato.
export function daysUntilExpiry(doc, now = new Date()) {
  if (!doc?.expiresOn) return null;
  const a = Date.parse(`${isoDay(now)}T00:00:00Z`);
  const b = Date.parse(`${doc.expiresOn}T00:00:00Z`);
  return Math.round((b - a) / 86400000);
}

// 'missing' | 'pending' | 'approved' | 'rejected' | 'expired'
export function documentState(doc, now = new Date()) {
  if (!doc || !Array.isArray(doc.files) || doc.files.length === 0) return 'missing';
  const days = daysUntilExpiry(doc, now);
  if (days !== null && days < 0) return 'expired';
  if (doc.status === 'approved') return 'approved';
  if (doc.status === 'rejected') return 'rejected';
  return 'pending';
}

export function isDriverDocumented(documents, now = new Date()) {
  if (!documents) return false;
  return REQUIRED_KEYS.every(k => documentState(documents[k], now) === 'approved');
}
